import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/services/helper.service';
import { AuthService } from "../../services/auth.service";

@Component ({
	selector: 'app-left-sidebar',
	templateUrl: './leftsidebar.component.html',
	styleUrls: ['./leftsidebar.component.scss'],
	standalone: true,
	imports: [
		CommonModule
	]
})
export class LeftSideBarComponent implements OnInit, OnDestroy
{
	public activeLink: string = 'Dashboard'
	public isSlideBarExpanded: boolean = false;
	public menu: any = []
	public hasViewUserAccess: any = false;
	public hasViewAuditlogAccess: any = false;
	public hasViewDownLineAccessAccess: any = false;
	public hasViewCommissionReportAccess: any = false;
	public hasViewSettingsAccess: any = false;
	public hasViewReferralAccess: any = false;
	public hasViewTrainingAdminAccess: any = false;

	private permissionsSub: Subscription | null = null;

	// Services using inject() function
	private router = inject(Router);
	private helperService = inject(HelperService);
	private authService = inject(AuthService);

	ngOnInit() {
		// GET THE CURRENT ROUTE.
		this.setActiveLink(this.router.url);

		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				this.setActiveLink(event.url);
			}
		});

		// REBUILD MENU WHEN PERMISSIONS ARE LOADED AFTER LOGIN (FIRST LOGIN RACE CONDITION).
		this.permissionsSub = this.authService.permissionsLoaded.subscribe(() => {
			this.buildMenu();
		});
	}

	ngOnDestroy() {
		this.permissionsSub?.unsubscribe();
	}

	constructor() {
		this.buildMenu();
	}

	private buildMenu() {
		// GET THE PERMISSIONS FOR THE VIEW USER.
		this.hasViewUserAccess = this.authService.hasPermission ('VIEWLISTOFUSERS');

		// GET THE PERMISSIONS FOR THE VIEW AUDIT LOG.
		this.hasViewAuditlogAccess = this.authService.hasPermission ('VIEWAUDITTRAIL');

		// GET THE PERMISSIONS FOR THE VIEW LINE MEMBERS.
		this.hasViewDownLineAccessAccess = this.authService.hasPermission ('VIEWDOWNLINEMEMBERS');

		// GET THE PERMISSIONS FOR THE VIEW COMMISSION REPORT.
		this.hasViewCommissionReportAccess = this.authService.hasPermission ('VIEWCOMMISSIONREPORT');

		// GET THE PERMISSIONS FOR THE VIEW SETTINGS.
		this.hasViewSettingsAccess = this.authService.hasPermission ('VIEWSETTINGS');

		// GET THE PERMISSIONS FOR THE VIEW SETTINGS.
		this.hasViewReferralAccess = this.authService.hasPermission('VIEWREFERRALLINKS');

		// GET THE PERMISSIONS FOR TRAINING ADMIN.
		this.hasViewTrainingAdminAccess = this.authService.hasPermission('VIEWTRAININGADMIN');

		this.menu =
			[
				{
					icon: '../../../assets/images/sidebar/dashboard.svg',
					title: 'Dashboard',
					url: "dashboard",
					newurl: "dashboard",
					isVisible: true,
				},
				{
					icon: '../../../assets/images/sidebar/edit.svg',
					title: 'Loan Application',
					url: "loan-application",
					newurl: "loan-application",
					isVisible: false,
				},
				{
					icon: '../../../assets/images/sidebar/logs.svg',
					title: 'Audit Log',
					url: "auditlog",
					newurl: "auditlog",
					isVisible: this.hasViewAuditlogAccess
				},
				{
					icon: '../../../assets/images/sidebar/users.svg',
					title: 'Users',
					url: "users",
					newurl: "users",
					isVisible: this.hasViewUserAccess,
				},
				{
					icon: '../../../assets/images/sidebar/group_icon.svg',
					title: 'Downline Members',
					url: "downlinemembers",
					newurl: "downlinemembers",
					isVisible: this.hasViewDownLineAccessAccess,
				},
				{
					icon: '../../../assets/images/sidebar/dashboard.svg',
					title: 'Commission Report',
					url: "commission-report",
					newurl: "commission-report",
					isVisible: this.hasViewCommissionReportAccess,
				},
				{
					icon: '../../../assets/images/sidebar/setting.svg',
					title: 'Settings',
					url: "settings",
					newurl: "settings",
					isVisible: this.hasViewSettingsAccess,
				},
				{
					icon: '../../../assets/images/sidebar/submitted_application.png',
					title: 'Submitted Applications',
					url: "submitted-applications",
					newurl: "submitted-applications",
					isVisible:true,
				},
				{
					icon: '../../../assets/images/sidebar/referral_link.png',
					title: 'Referral Links',
					url: "referral-links",
					newurl: "referral-links",
					isVisible: this.hasViewReferralAccess,
				},
				{
					icon: '../../../assets/images/sidebar/logs.svg',
					title: 'Training Admin',
					url: "training-admin",
					newurl: "training-admin",
					isVisible: this.hasViewTrainingAdminAccess,
				}
			]

		// REAPPLY ACTIVE LINK VISIBILITY AFTER REBUILDING.
		this.setActiveLink(this.router.url);
	}



	setActiveLink(urlstr: string) {
		const urlArray = urlstr.split ('/');
		this.activeLink = urlArray[1];

		let loanItem = this.menu.find((x:any) => x.newurl === 'loan-application');
		let auditItem = this.menu.find((x:any) => x.newurl === 'auditlog');

		if (!loanItem || !auditItem) return;

		loanItem.url = loanItem.newurl;
		auditItem.url = auditItem.newurl;
		loanItem.isVisible = false;
		auditItem.isVisible = false;

		// IF WE ARE IN EDIT MODE OF A LOAN APPLICATION ID.
		if ((this.activeLink == 'loan-application' || this.activeLink == 'auditlog') && urlArray[2]) {
			loanItem.isVisible = true;
			loanItem.url = loanItem.newurl+'/'+urlArray[2];

			if (this.hasViewAuditlogAccess)
			{
				auditItem.isVisible = true;
				auditItem.url = auditItem.newurl+'/'+urlArray[2];
			}
		}

		if (this.activeLink == 'review-application') {
			this.activeLink = 'submitted-applications';
		}
	}

	public expandSlideBar ()
	{
		this.isSlideBarExpanded = !this.isSlideBarExpanded
	}

	// NAVIGATE THE USER TO THE SELECTED ROUTE.
	public navigateTo(menuItem: any)
	{
		if (menuItem.isExternal) {
			const token = localStorage.getItem('token');
			const url = token ? `${menuItem.externalUrl}?token=${token}` : menuItem.externalUrl;
			window.open(url, '_blank');
			return;
		}

		// this.router.navigate (['/' + menuItem.url])
		if (this.helperService.isFormModified === true)
		{
			this.helperService.onSideMenuChange.next(menuItem.url);
		}
		else{
			this.router.navigate (['/' + menuItem.url]);
		}
	}
}
